<template>
  <div class="crowdfunding">
    <!-- BIG SLOGAN -->
    <div class="container">
      <p class="crowd-or-rais">
        <span class="domore-blue-1">CROWDFUNDING</span>
        <span class="or">/</span>
        <router-link to="/fundraising" class="rais-or">FUNDRAISING</router-link>
      </p>
      <h1 class="big-slogan-blue">{{ $t("project.slogan") }}</h1>
      <h2 class="mb-50">{{ $t("project.chooseCategory") }}</h2>
    </div><!-- .container -->

    <!-- FILTERS -->
    <div class="container filters">
      <search :categories="categories" :type="'crowdfunding'"></search>
    </div><!-- .container .mb-50 -->

    <!-- CROWDFUNDING LISTING -->
    <div class="container">
      <div class="all-categories mb-30">
        <strong>CROWDFUNDING:</strong> {{ this.search.category }}
      </div>
      <div class="row">
        <div v-for="(project, index) in projects" :key="project.id">
          <div v-if="showSpecialist(index)">
            <specialist-tile :specialist="specialists[index % 3]" size="col-md-6" style="height: 300px"></specialist-tile>
          </div>
          <crowdfunding-tile :project="project" size="col-md-6"></crowdfunding-tile>
        </div>
      </div><!-- .row -->
      <button v-if="!isLast" :disabled="show_loader" type="button" @click="showMore()" class="btn btn-lg button-more-crowd">
        <span v-if="!show_loader">{{ $t("showMore") }} </span>
        <clip-loader :loading="show_loader" :color="'#fff'" :size="'15px'"></clip-loader>
      </button>
    </div><!-- .container -->

    <!-- CROWDFUNDING ALL CATEGORIES -->
    <div class="container mb-30">
      <div class="all-categories">
        <strong>CROWDFUNDING:</strong> {{ $t("project.allCategories") }}
      </div>
      <div class="all-categories-list-crowd">
        <ul class="list-inline">
          <li v-for="category in categories">
            <router-link :to="{ name: 'crowdfunding', query: { category_id: category.id , category: category.name } }">{{ category.name }}</router-link>
          </li>
        </ul>
      </div><!-- .all-categories-list-crowd -->
    </div><!-- .container .mb-30 -->

    <crowd-or-rais></crowd-or-rais>
  </div>
</template>

<script>
// API
import userApi from '@/api/v1/user';
import projectsApi from '@/api/v1/projects';
// Components
import CrowdfundingTile from '@/components/Project/Tiles/Crowdfunding';
import SpecialistTile from '@/components/Profile/Tiles/Specialist';
import CrowdOrRais from '@/components/CrowdOrRais';
import Search from '@/components/Project/Search';
import ClipLoader from 'vue-spinner/src/ClipLoader';

function showSpecialist(index) {
  return index !== 0 && !(index % 3) && this.specialists[index % 3];
}

export default {
  components: {
    CrowdfundingTile,
    SpecialistTile,
    CrowdOrRais,
    Search,
    ClipLoader,
  },
  data() {
    return {
      projects: [],
      specialists: [],
      tileSize: 'col-md-6',
      categories: [],
      countries: [],
      page: 1,
      moreProjectsAvaliable: true,
      show_loader: false,
      isLast: true,
    };
  },
  computed: {
    search() {
      return {
        category_id: this.$route.query.category_id || '',
        category: this.$route.query.category,
        country_id: this.$route.query.country_id || '',
        title: this.$route.query.title,
        city: this.$route.query.city,
        status: this.$route.query.status,
      };
    },
  },
  methods: {
    getProjects() {
      projectsApi.search(this.search, (response) => {
        this.show_loader = false;
        this.projects.push(...response.projects);
        this.isLast = response.is_last;
      }, this.page);
    },
    showMore() {
      this.show_loader = true;
      this.page += this.page;
      this.getProjects();
    },
    showSpecialist,
  },
  created() {
    projectsApi.getCategories((categories) => {
      this.categories = categories;
    }, true);
    userApi.getAllUsers((users) => {
      this.specialists = users;
    });
    this.getProjects();
  },
  watch: {
    $route() {
      this.search.crowdfunding = true;
      this.projects = [];
      this.page = 1;
      this.isLast = true;
      this.getProjects();
    },
  },
};
</script>



// WEBPACK FOOTER //
// Index.vue?bf2f74ca